import styled from "styled-components";
import {eyebrowTextCss} from "theme/typography";
import {fontFamilies, fontWeights, topbar} from "theme/tokens";

export const Wrap = styled.main`
	width: 100%;
	max-width: 1240px;
	margin: 0 auto;
	padding: 48px 22px 72px;
	box-sizing: border-box;
	text-align: center;

	@media (max-width: 900px) {
		padding: 32px 16px 56px;
	}

	@media (max-width: 480px) {
		padding: calc(${topbar.heightMobile} + 12px) 12px 44px;
	}
`;

export const Header = styled.header`
	max-width: 680px;
	margin: 0 auto 10px;
`;

export const Eyebrow = styled.div`
	${eyebrowTextCss};
	color: ${({theme}) => (theme.tokens.mode === "dark" ? theme.tokens.segInk : theme.tokens.blue)};
	font-weight: 700;
	letter-spacing: 0.1em;
`;

export const Title = styled.h1`
	margin: 9px 0 0;
	font-family: ${fontFamilies.displaySerif};
	font-weight: ${fontWeights.display};
	/* Restored with the display face (ui#1257). ui#1219 had cut this to clamp(28px, 4.2vw, 38px)
	   because in a face that set ~1.5x wider the header took a second line at every desktop width in
	   BOTH languages, pushing the lede and the plan grid down the page. Re-measured in this face it
	   holds one line from 901px up in both: 525.39px EN / 514.03px RO at the 901px width and 606.45 /
	   593.34 at 1440, all inside the 680px header measure, and still one line at 500px. It takes a
	   second line on a 375px phone, which is where this ramp has always put it — the features header
	   opposite carries the reasoning for why a page title wrapping there is left alone. */
	font-size: clamp(34px, 5vw, 52px);
	line-height: 1.02;
	letter-spacing: -0.015em;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Lede = styled.p`
	margin: 12px auto 0;
	max-width: 520px;
	font-size: 15px;
	line-height: 1.55;
	color: ${({theme}) => theme.tokens.ink2};

	/* The lede ends with the landing-page link (ui#1800), and nothing else styles an anchor for it:
	   this app declares no global \`a\` rule, so without these the link paints in the user agent's own
	   #0000EE and is unreadable on the dark surface. Same treatment as a link inside content-page prose
	   (see ContentPage) rather than the homepage guide note's underline-on-hover: this one sits mid
	   paragraph in running text, where an underline is what tells a reader it is a link without asking
	   them to notice a color. */
	a {
		color: ${({theme}) => theme.tokens.blue};
		text-decoration: underline;
		text-underline-offset: 0.16em;
	}

	a:focus-visible {
		outline: 2px solid ${({theme}) => theme.tokens.focusOutline};
		outline-offset: 2px;
		border-radius: 3px;
	}
`;
